import React from 'react';
import classes from './ExpressionOfInterestFeaturesSection.module.css';
import { AppConstants } from '../../../constants/AppConstants';
import { FeatureCards } from './FeatureCards';

export const ExpressionOfInterestFeaturesSection = () => {
    return (
        <>
            <div id="features" className={classes.featureSection}>
                <h1 className={classes.heading}>Exclusive features coaches use on Qrencia</h1>
                <FeatureCards cardDetails={AppConstants.qrenciaFeatures} />
            </div>
        </>
    );
};
